export function passwordLength(str, min, max) {
  return str === undefined || min === undefined || max === undefined
    ? false
    : str.trim().length >= min && str.trim().length <= max;
}
